import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['topic', 'description'];

    prefill(event) {
        if (this.descriptionTarget.value === '' && event.currentTarget.value === 'points') {
            this.descriptionTarget.value = 'Match du saknar poäng för: \n\n' +
            'Bokningsnummer om hemmamatch: \n\n' +
            'Ansökningsnummer om bortamatch: \n\n' +
            'Om du saknar nummer, fyll i namnet på den som gjorde bokningen.';
        }
    }
}
